import { render, staticRenderFns } from "./ElCard.vue?vue&type=template&id=4e1650da"
import script from "./ElCard.vue?vue&type=script&lang=js"
export * from "./ElCard.vue?vue&type=script&lang=js"
import style0 from "./ElCard.vue?vue&type=style&index=0&id=4e1650da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports